import { number, object } from "yup";

import { MIN_RECORD_MODE_TIME_UPDATE, MAX_RECORD_MODE_TIME_UPDATE } from "./constants";

export const validationSchema = object().shape({
  recordModeTimeUpdate: number()
    .typeError("form.validations.badInput")
    .required("form.validations.valueMissing")
    .min(MIN_RECORD_MODE_TIME_UPDATE, "form.validations.rangeUnderflow")
    .max(MAX_RECORD_MODE_TIME_UPDATE, "form.validations.rangeOverflow"),
});
